import SpsCode from "./Code";

export default SpsCode;

export { SpsCode };
